<template>
  <div class="flex flex-row gap-2 items-end px-4 pt-4">
    <div class="flex flex-col gap-1.5 grow">
      <Button
        @click="openSortByDialog = true"
        :label="`${t('components.sort_by.label')} : ${sortBy?.label}`"
        variant="secondary"
        type="gray"
        size="xl"
      />
    </div>
    <div class="flex flex-col">
      <IconButton
        size="xl"
        variant="secondary"
        type="gray"
        @click="toggleOrder"
      >
        <Icon
          name="arrow-long-down"
          class="transition-all duration-300 ease-in"
          :class="{
            'rotate-180': orderBy === 'asc',
          }"
          size="xl"
        />
      </IconButton>
    </div>

    <Dialog
      @update:open="openSortByDialog = !openSortByDialog"
      :open="openSortByDialog"
      :confirmLabel="t('components.buttons.save')"
      :showCancel="false"
      :showConfirm="false"
      variant="default"
      size="default"
      side="bottom"
    >
      <template #header>
        <DrawerHeader
          :title="t('components.sort_by.label')"
          v-bind="{
            variant: 'tertiary',
            type: 'gray',
            size: 'xl',
          }"
          class="bg-primary max-md:rounded-none border-b border-secondary"
        />
      </template>
      <template #content>
        <div class="bg-primary overflow-y-auto flex flex-col gap-1 p-4">
          <Default
            v-for="option in options"
            :key="option.id"
            :item="option"
            :checked="isChecked(option)"
            @click="handleSort(option)"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { IconButton, Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { computed, ref } from "vue";
import { Dialog } from "@/SharedComponents/Dialog";
import { DrawerHeader } from "@/SharedComponents/Drawer";
import { useI18n } from "vue-i18n";
import { Default } from "@/SharedComponents/Sorting/Drawer/Inputs";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
});

const openSortByDialog = ref(false);
const { t } = useI18n();

const orderBy = computed(() => props.modelValue.order_by);
const sortBy = computed(() =>
  props.options.find((option) => option.id === props.modelValue.sort_by)
);

const emit = defineEmits(["update:sorting"]);

const handleSort = (option) => {
  const newOrder = option.id === sortBy.value.id ? !orderBy.value : true;
  emit("update:sorting", { id: option.id, desc: newOrder });
  openSortByDialog.value = false;
};

const toggleOrder = () => {
  emit("update:sorting", {
    id: sortBy.value.id,
    desc: orderBy.value === "desc" ? false : true,
  });
};

const isChecked = (option) => sortBy.value.id === option.id;
</script>
